import React from 'react'
import { reduxForm } from 'redux-form'
import {
  makeStyles,
  Backdrop,
  CircularProgress,
  // Input,
  styled,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

import { showAlertMessage } from '../store/alert/actions'
import { getChildrenRSPA } from '../store/classrooms/actions'
import {
  getPickupAuthorizations,
  getPickupAuthorizationRSPA
} from '../store/pickup/actions'
import { createPickupQueueRSPA } from '../store/pickup_queue/actions'

import { getPAChild } from '../store/pickup_authorization_child/actions'
import TabNavigation from '../components/shared/TabNavigation'
import PickupByChildView from '../components/view/PickupByChildView'
import PickupByResponsibleView from '../components/view/PickupByResponsibleView'
import Button from '../components/button/Button'
import StyledSVG from '../components/shared/StyledSVG'
import emptyAvatar from '../assets/icons/empty-avatar-icon.svg'
import yellowWarningSVG from '../assets/icons/rounded-yellow-warning.svg'
import crossAddSVG from '../assets/icons/cross-add-icon.svg'
import createQueueSuccessSVG from '../assets/icons/success-pickup-backdrop.svg'
import Modal from '../components/modal/Modal'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '98%',
    [theme.breakpoints.down('600')]: {
      padding: '16px'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093',
        [theme.breakpoints.down('600')]: {
          fontSize: 23
        }
      }
    },
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  },
  cross_add_wrapper: {
    width: 30,
    height: 30,
    borderRadius: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #264468',
    '& path': {
      fill: '#264468'
    }
  },
  backdrop_icon_wrapper: {
    width: 400,
    height: 320,
    borderRadius: 24,
    backgroundColor: '#386093',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '32px 56px 48px 48px',
    rowGap: 16,
    '& .title': {
      margin: 0,
      color: '#F1F3F4',
      fontWeight: 600,
      fontSize: 24
    },
    '& .subtitle': {
      margin: 0,
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: 14
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  authorization_confirm_modal: {
    overflow: 'auto',
    padding: 56,
    width: 500,
    height: 600,
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  authorization_confirm_modal_header: {
    marginBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    alignItems: 'flex-start',
    textAlign: 'start',
    '& h1': {
      margin: 0,
      color: '#386093',
      fontWeight: 600,
      fontSize: 24
    },
    '& p': {
      margin: 0,
      color: '#9B9B9B',
      fontWeight: 500,
      fontSize: 16
    }
  },
  authorization_users_wrapper: {
    marginBottom: 16,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: 16
  },
  authorization_user: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16
  },
  user_identification: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: 4,
    '& h1': {
      margin: 0,
      fontWeight: 600,
      fontSize: 18
    },
    '& p': {
      margin: 0,
      color: '#9B9B9B',
      fontWeight: 400,
      fontSize: 16
    }
  },
  authorization_data_wrapper: {
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8
  },
  authorization_data: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 4,
    '& p': {
      margin: 0,
      fontWeight: 500,
      fontSize: 16
    },
    '& .label': {
      color: '#9B9B9B'
    }
  },
  modal_warning: {
    marginBottom: 40,
    display: 'flex',
    alignItems: 'center',
    columnGap: 12,
    width: '100%',
    backgroundColor: '#FEF7DD',
    borderRadius: 16,
    padding: '8px 32px 8px 8px',
    '& p': {
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      textAlign: 'start'
    },
    '& span': {
      fontWeight: 600
    }
  },
  confirm_modal_btns_wrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16
  },
  filled_btn: {
    padding: 16,
    gap: 10,
    borderRadius: 8,
    width: 190,
    height: 48,
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none !important'
  },
  confirmation_modal_cancel: {
    backgroundColor: '#EF7C8F',
    color: '#FFFF',
    '&:hover': {
      backgroundColor: '#EF7C8F'
    }
  },
  authorize_pickup_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    '&:hover': {
      backgroundColor: '#386093'
    }
  },
  tab_navigation_key_class: {
    marginBottom: '12px !important',
    fontWeight: '600 !important',
    fontSize: '28px !important',
    [theme.breakpoints.down('600')]: {
      fontSize: '18px !important'
    }
  },
  tab_navigation: {
    marginTop: 32,
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-end !important',
    marginBottom: 0
  }
}))

const UserPhoto = styled('img')(({ theme, bgImg }) => {
  return {
    minWidth: 56,
    height: 56,
    borderRadius: 16,
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const ContentByTab = props => {
  const { currentTab } = props
  if (currentTab === 'child') {
    return <PickupByChildView {...props} />
  }
  return <PickupByResponsibleView {...props} />
}

const PickupManualPage = ({
  authorizations,
  getChildrenRSPA,
  getPickupAuthorizations,
  getPickupAuthorizationRSPA,
  getPAChild,
  createPickupQueueRSPA,
  schoolId,
  currentUser,
  alert,
  authorizationChildrens
}) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('850'))
  const tabOptions = [
    { key: 'child', title: 'Aluno', style: { flex: '0 1 320px' } },
    { key: 'responsible', title: 'Responsável', style: { flex: '0 1 320px' } }
  ]
  const [currentTab, setCurrentTab] = React.useState('responsible')
  const [selectedChild, setSelectedChild] = React.useState([])
  const [pickupConfirmationModal, setPickupConfirmationModal] = React.useState({
    id: null,
    open: false,
    data: {}
  })
  const [backdrop, setBackdrop] = React.useState({ open: false, svg: null })

  const handleCreatePickupQueue = authorization => {
    handleClosepPickupConfirmationModal()
    setBackdrop(prev => ({ ...prev, open: true }))
    createPickupQueueRSPA({
      pickup_authorization_id: authorization,
      pickup_queue_children_attributes: selectedChild.map(child => ({
        child_id: child.id
      })),
      status: 'finished',
      picked_at: moment(new Date()).format('DD/MM/YYYY HH:mm'),
      approved_by_id: currentUser.id
    })
      .then(res => {
        setBackdrop(prev => ({ ...prev, svg: createQueueSuccessSVG }))
      })
      .catch(err => {
        console.error(err)
        setBackdrop({ svg: null, open: false })
        alert('Erro ao concluir a retirada.', 'error')
      })
  }

  const handleClosepPickupConfirmationModal = () => {
    setPickupConfirmationModal({ id: null, open: false, data: {} })
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          {matches && (
            <div className={classes.cross_add_wrapper}>
              <StyledSVG src={crossAddSVG} height={12} width={12} />
            </div>
          )}
          <h1>Retirada Manual</h1>
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <p className='subtitle'>
        Realize a retirada manualmente pesquisando pelo nome do aluno.
      </p>
      <TabNavigation
        keyClass={classes.tab_navigation_key_class}
        emptyOptions={1}
        flexFixedLayout
        defaultOption={1}
        baseClass={classes.tab_navigation}
        options={tabOptions.map((item, index) => {
          return {
            id: index,
            key: item.title,
            style: item.style,
            handleChange: () => setCurrentTab(item.key)
          }
        })}
      />
      <ContentByTab
        getChildrenRSPA={getChildrenRSPA}
        authorizations={authorizations}
        getPickupAuthorizations={getPickupAuthorizations}
        getPickupAuthorizationRSPA={getPickupAuthorizationRSPA}
        getPAChild={getPAChild}
        authorizationChildrens={authorizationChildrens}
        currentTab={currentTab}
        setPickupConfirmationModal={setPickupConfirmationModal}
        setParentComponentChild={setSelectedChild}
      />
      <Backdrop
        onClick={() => setBackdrop(prev => ({ svg: null, open: false }))}
        className={classes.backdrop}
        open={backdrop.open}
      >
        {backdrop.svg ? (
          <div className={classes.backdrop_icon_wrapper}>
            <StyledSVG width={120} height={110} src={createQueueSuccessSVG} />
            <h1 className='title'>Retirada Concluída</h1>
            <p className='subtitle'>
              {selectedChild.map(item => item.name).join(', ')} já está(ão) com
              o responsável. Tenha um ótimo dia!
            </p>
          </div>
        ) : (
          <CircularProgress />
        )}
      </Backdrop>
      <Modal
        open={pickupConfirmationModal.open}
        handleClose={handleClosepPickupConfirmationModal}
        disablePadding
      >
        <div className={classes.authorization_confirm_modal}>
          <div className={classes.authorization_confirm_modal_header}>
            <h1>Confirmar autorização de saída</h1>
            <p>
              Você está prestes a autorizar a retidada do aluno por este
              responsável
            </p>
          </div>
          <div className={classes.authorization_users_wrapper}>
            <div className={classes.authorization_user}>
              <UserPhoto
                key={pickupConfirmationModal.id}
                src={
                  pickupConfirmationModal.data?.responsible_photo || emptyAvatar
                }
              />
              <div className={classes.user_identification}>
                <h1>{pickupConfirmationModal.data?.responsible_name}</h1>
                <p>{`Responsável${
                  pickupConfirmationModal.data?.responsible_type
                    ? ` - ${pickupConfirmationModal.data?.responsible_type}`
                    : ''
                }`}</p>
              </div>
            </div>
            {selectedChild.map(child => {
              return (
                <div key={child?.id} className={classes.authorization_user}>
                  <UserPhoto
                    key={child?.id}
                    src={child?.avatar_url || emptyAvatar}
                  />
                  <div className={classes.user_identification}>
                    <h1>{child?.name}</h1>
                    <p>Aluno</p>
                  </div>
                </div>
              )
            })}
          </div>
          <div className={classes.authorization_data_wrapper}>
            {[
              { label: 'Tipo de autorização:', value: 'type' },
              { label: 'Placa do veículo:', value: 'vehicle_plate' }
            ].map(item => {
              const hasAttribute = !!pickupConfirmationModal.data
                ?.authorization_data?.[item.value]
              if (hasAttribute) {
                return (
                  <div key={item.value} className={classes.authorization_data}>
                    <p className='label'>{item.label}</p>
                    <p>
                      {
                        pickupConfirmationModal.data?.authorization_data?.[
                          item.value
                        ]
                      }
                    </p>
                  </div>
                )
              }
            })}
          </div>
          <div className={classes.modal_warning}>
            <StyledSVG src={yellowWarningSVG} width={20} height={20} />
            <p>
              <span>Ao confirmar</span>, a saída ficará registrada no sistema e
              disponível para auditoria.
            </p>
          </div>
          <div className={classes.confirm_modal_btns_wrapper}>
            <Button
              onClick={handleClosepPickupConfirmationModal}
              className={` ${classes.filled_btn} ${
                classes.confirmation_modal_cancel
              }`}
              type='button'
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.filled_btn} ${
                classes.authorize_pickup_btn
              }`}
              type='button'
              onClick={() =>
                handleCreatePickupQueue(pickupConfirmationModal.id)
              }
            >
              Autorizar saída
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
const mapStateToProps = (state, props) => ({
  authorizations: state.authorizations,
  schoolId: state.school?.currentSchool?.school_id,
  currentUser: state?.auth?.user?.data,
  authorizationChildrens: state.pickup_authorization_child
})

const mapDispatchToProps = dispatch => ({
  getChildrenRSPA: data => dispatch(getChildrenRSPA.request(data)),
  getPickupAuthorizations: data => dispatch(getPickupAuthorizations(data)),
  getPickupAuthorizationRSPA: data =>
    dispatch(getPickupAuthorizationRSPA.request(data)),
  getPAChild: data => dispatch(getPAChild(data)),
  createPickupQueueRSPA: data => dispatch(createPickupQueueRSPA.request(data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ManualAuthorizationPage'
  })(PickupManualPage)
)
